const assetCache = new Map();
export const loadScript = (url) => {
    if (assetCache.has(url)) {
        return assetCache.get(url);
    }
    const promise = new Promise((resolve, reject) => {
        var _a;
        const script = document.createElement('script');
        script.id = `loaded-script-${assetCache.size}`;
        script.addEventListener('load', resolve);
        script.addEventListener('error', reject);
        script.async = true;
        script.src = url;
        if (document.currentScript) {
            (_a = document.currentScript.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, document.currentScript);
        }
        else {
            (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
        }
    });
    assetCache.set(url, promise);
    // Allow for loadScript(myURL, 'MyObj').then(MyObj => { console.log('MyObj loaded', MyObj)});
    // Script should add window.MyObj
    // if (name && global[name]) {
    //   return promise.then(() => global[name]);
    // }
    return promise;
};
//# sourceMappingURL=loaders.js.map